/**
 * @copyright       Palace Resorts
 * @description     HELPER para funciones del S3
 */
import { Storage } from "aws-amplify";
Storage.configure({
  customPrefix: {
    public: "private/",
    protected: "private/",
    private: "private/",
  },
});
const _upload = async (file: any, fileName: string) => {
  let result: object = {};
  try {
    return await Storage.put(fileName, file, {
      contentType: file.contentType,
    });
  } catch (error) {
    console.log("Error uploading file:  ", error);
    return result;
  }
};

const _getFile = async (fileName: string) => {
  let result: object = {};
  try {
    result = await Storage.get(fileName, { download: true });
    return result;
  } catch (error) {
    console.log("Error getting file: ", error);
    return result;
  }
};
const _deleteFile = async (fileName: string) => {
  let result: object = {};
  try {
    result = await Storage.remove(fileName);
    return result;
  } catch (error) {
    console.log("Error delete file: ", error);
    return result;
  }
};
export const S3 = {
  upload: (file: any, fileName: string) => {
    return _upload(file, fileName);
  },
  delete: (fileName: string) => {
    return _deleteFile(fileName);
  },
  get: (fileName: string) => {
    return _getFile(fileName);
  },
};
